import type { JSX, PropsWithChildren } from 'react';

import { PetitionEditBannerStateContextProvider } from './context';
import { useBannerState } from './hook';

export function PetitionEditBannerStateProvider({ children }: PropsWithChildren<EmptyProps>): JSX.Element | null {
	const bannerState = useBannerState();

	return <PetitionEditBannerStateContextProvider {...bannerState}>{children}</PetitionEditBannerStateContextProvider>;
}
